<template>
    <div>
        <vs-popup v-if="show" :active.sync="show" :title="renderTitle">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-input class="w-full" label="Naam" v-model="location.city"/>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mb-2">
                    <vs-list>
                        <vs-list-item v-for="item in JSON.parse(location.postal_code)" :subtitle="item"></vs-list-item>
                    </vs-list>
                </div>
            </div>
            <div class="vx-row" style="float: right">
                <div class="vx-col">
                    <vs-button class="w-full vs-con-loading__container"
                               id="save-delivery-location"
                               ref="loadableButton"
                    >Opslaan
                    </vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                location: null,
                createLocation: {
                    city: ""
                },
                show: false
            }
        },
        computed: {
            renderTitle() {
                return "Bezorglocatie " + (this.location.city == null ? "toevoegen" : "bewerken");
            }
        },

        methods: {
            saveDeliveryLocation(location) {
                this.$util.loading('#save-delivery-location', this.$vs);
            }
        },
        mounted() {
            this.$events.listen('open-delivery-location', (location) => {
                this.location = location;
                console.log(location);
                this.show = true;
            });
        }
    }
</script>